var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"value":_vm.value}},[_vm._v(_vm._s(_vm.inner))])
}
var staticRenderFns = []

export { render, staticRenderFns }